import { defineStore } from 'pinia';

export const useRecommendedJobsStore = defineStore({
  id: 'useRecommendedJobsStore',
  state: () => {
    return {
      currentPage: 0,
      currentPageIndex: 0,
      error: null,
      jobs: [],
      loading: false,
      orderIds: [],
      pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 17,
        size: 50,
        totalElements: 0,
        totalPages: 1,
      },
      rowsPerPage: '50',
    };
  },
  actions: {
    setOrderIds(orderIds) {
      this.orderIds = orderIds;
    },
    async fetchRecommendedJobs(orderIds) {
      this.loading = true;
      this.error = null;
      this.jobs = [];

      const body = { orderIds };

      try {
        const response = await useAcvFetch('api/transport-requests/available', {
          method: 'POST',
          body,
          initialCache: false,
          params: {
            // page: this.number,
            // size: rowsPerPage.value,
          },
        });

        this.jobs = response.data.value.data.content;
        this.pagination = response.data.value.data.pagination;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
});
